import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';
import { ChatRoomSummary } from '../chatbot/chatbot.service';

/**
 * Multi-room picker for the Adaline widget's live-chat entry point — shown
 * when ChatbotService.checkRoomsThenOpen() finds more than one room for the
 * logged-in user. Mirrors market_app's ChatRoomPicker (Flutter): sorted by
 * last activity, unread badge per room, delete (delete-for-me) per row.
 */
@Component({
  selector: 'app-chat-room-picker',
  standalone: true,
  imports: [NgClass],
  templateUrl: './chat-room-picker.component.html',
  styleUrls: ['./chat-room-picker.component.scss'],
})
export class ChatRoomPickerComponent {
  @Input() rooms: ChatRoomSummary[] = [];
  @Output() select = new EventEmitter<ChatRoomSummary>();
  @Output() delete = new EventEmitter<ChatRoomSummary>();

  get sortedRooms(): ChatRoomSummary[] {
    return [...this.rooms].sort(
      (a, b) => new Date(b.last_activity).getTime() - new Date(a.last_activity).getTime(),
    );
  }

  onSelect(room: ChatRoomSummary): void {
    this.select.emit(room);
  }

  onDelete(event: Event, room: ChatRoomSummary): void {
    event.stopPropagation();
    if (!confirm(`למחוק את השיחה עם ${room.name}? ההודעות יימחקו רק אצלך.`)) return;
    this.delete.emit(room);
  }

  formatTime(iso: string): string {
    const dt = new Date(iso);
    const now = new Date();
    const sameDay = dt.getFullYear() === now.getFullYear()
      && dt.getMonth() === now.getMonth()
      && dt.getDate() === now.getDate();
    if (sameDay) {
      return `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`;
    }
    return `${dt.getDate()}/${dt.getMonth() + 1}`;
  }
}
